export default {
  Evidence: [
    {
      id: '1',
      name: 'Newspaper Article',
      plot: 'Some plot',
      type: 'POLICE_MANILLA_FOLDER',
      status: 'PUBLISHED',
      content: `<p style="text-align: right;"><span style="font-family: 'times new roman', times, serif;"><img style="display: block; margin-left: auto; margin-right: auto;" src="http://assets.stickpng.com/images/5842f0efa6515b1e0ad75b1d.png" alt="" width="484" height="252" /><span style="font-size: 14pt;">13th August 1928&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</span></span></p>
      <h2 style="text-align: left; padding-left: 40px;"><span style="font-family: 'times new roman', times, serif;">Forthcoming marriages</span></h2>
      <p style="text-align: left; padding-left: 40px;"><span style="font-family: 'times new roman', times, serif; font-size: 14pt;">Earl Edward Morstan and Miss Mary Barton</span></p>
      <p style="text-align: left; padding-left: 40px;"><span style="font-family: 'times new roman', times, serif; font-size: 14pt;">The engagement is announced between Earl Edward Morstan, Earl of Buckingham, son of Charles Morstan (deceased), and Eleanor Morstan, Countess of Buckingham, and Mary, daughter of Mr George Barton and Mrs Elizabeth Barton (deceased), of Sutton Coldfield, Warwickshire.</span></p>`,
    },
    {
      id: '2',
      name: 'Blackmail Note',
      plot: 'Some plot',
      type: 'ARTICLE_PAGE_OPEN',
      status: 'DRAFT',
      content: `<div id="document-style" style="background-image: url('https://swall.teahub.io/photos/small/190-1904475_old-book-old-paper-background-hd.jpg'); background-repeat: no-repeat; background-size: cover;">
      <p style="text-align: left; padding-left: 40px;"><span style="font-family: gugia, cursive; font-size: 18pt;"><strong><br /><span style="font-size: 18pt;">2nd August 1928</span></strong></span></p>
      <p style="text-align: left; padding-left: 40px;"><span style="font-family: gugia, cursive; font-size: 18pt;">My dear diary, I have been so fed up of me <br /></span><span style="font-family: gugia, cursive; font-size: 18pt;">writing </span><span style="font-family: gugia, cursive; font-size: 18pt;">about my son Edward and his <br /></span><span style="font-family: gugia, cursive; font-size: 18pt;">wicked ways over the last few years. </span><br /><br /><span style="font-family: gugia, cursive; font-size: 18pt;">We have finally found a solution - <br /></span><span style="font-family: gugia, cursive; font-size: 18pt;">he is going to marry Mary Barton. She <br />seems nice enough and her father is going <br />to help us pay off all our debts.</span><br /><br /><span style="font-family: gugia, cursive; font-size: 18pt;">Hopefully Edward will be able to <br />settle down.</span></p>
      <p style="text-align: left; padding-left: 40px;">&nbsp;</p>
      <p style="text-align: left;">&nbsp;</p>
      </div>`,
    },
    {
      id: '3',
      name: "Eleanor's Diary",
      plot: 'Some plot',
      type: 'DEVICE_PHONE_UNLOCK',
      status: 'DRAFT',
      content: '',
    },
  ],
  Plot: [
    {
      id: '1',
      name: 'First Plot 1',
      status: 'PUBLISHED',
      evidenceCode1: '1234',
      evidenceCode2: '5678',
      evidenceCode3: '9123',
      suspectsCode: '3456',
      discountCode: 'SUMMER25',
      maxActors: 7,
      image: {
        url: 'https://image.shutterstock.com/image-vector/ui-image-placeholder-wireframes-apps-260nw-1037719204.jpg',
      },
      description: 'Plot#1 description',
    },
    {
      id: '2',
      name: 'Some Plot 2',
      status: 'DRAFT',
      evidenceCode1: '1234',
      evidenceCode2: '5678',
      evidenceCode3: '9123',
      suspectsCode: '3456',
      discountCode: 'SUMMER25',
      maxActors: 7,
      image: {
        url: 'https://image.shutterstock.com/image-vector/ui-image-placeholder-wireframes-apps-260nw-1037719204.jpg',
      },
      description: 'Plot#2 description',
    },
    {
      id: '3',
      name: 'Other Plot 3',
      status: 'DRAFT',
      evidenceCode1: '1234',
      evidenceCode2: '5678',
      evidenceCode3: '9123',
      suspectsCode: '3456',
      discountCode: 'SUMMER25',
      maxActors: 7,
      image: {
        url: 'https://image.shutterstock.com/image-vector/ui-image-placeholder-wireframes-apps-260nw-1037719204.jpg',
      },
      description: 'Plot#3 description',
    },
  ],
  PlotSuspect: [
    {
      id: '1',
      plotId: '1',
      name: 'Susan Suspect',
      priorityNumber: 1,
      murderBoxChecked: true,
      motive: 'Motivation ...',
    },
    {
      id: '2',
      plotId: '1',
      name: 'Joey Suspect',
      priorityNumber: 2,
      murderBoxChecked: false,
      motive: 'Motivation ...',
    },
    {
      id: '3',
      plotId: '3',
      name: 'Andrew Suspect',
      priorityNumber: 3,
      murderBoxChecked: false,
      motive: 'Motivation ...',
    },
  ],
  PlotEvidence: [
    {
      id: '1',
      plot: {
        id: '1',
        name: 'First Plot 1',
        status: 'PUBLISHED',
        evidenceCode1: '1234',
        evidenceCode2: '5678',
        evidenceCode3: '9123',
        suspectsCode: '3456',
        discountCode: 'SUMMER25',
        maxActors: 7,
        image: {
          url: 'https://image.shutterstock.com/image-vector/ui-image-placeholder-wireframes-apps-260nw-1037719204.jpg',
        },
        description: 'Plot#1 description',
      },
      evidence: {
        id: '1',
        name: 'Newspaper Article',
        plot: 'Some plot',
        type: 'POLICE_MANILLA_FOLDER',
        status: 'PUBLISHED',
        content: `<p style="text-align: right;"><span style="font-family: 'times new roman', times, serif;"><img style="display: block; margin-left: auto; margin-right: auto;" src="http://assets.stickpng.com/images/5842f0efa6515b1e0ad75b1d.png" alt="" width="484" height="252" /><span style="font-size: 14pt;">13th August 1928&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</span></span></p>
      <h2 style="text-align: left; padding-left: 40px;"><span style="font-family: 'times new roman', times, serif;">Forthcoming marriages</span></h2>
      <p style="text-align: left; padding-left: 40px;"><span style="font-family: 'times new roman', times, serif; font-size: 14pt;">Earl Edward Morstan and Miss Mary Barton</span></p>
      <p style="text-align: left; padding-left: 40px;"><span style="font-family: 'times new roman', times, serif; font-size: 14pt;">The engagement is announced between Earl Edward Morstan, Earl of Buckingham, son of Charles Morstan (deceased), and Eleanor Morstan, Countess of Buckingham, and Mary, daughter of Mr George Barton and Mrs Elizabeth Barton (deceased), of Sutton Coldfield, Warwickshire.</span></p>`,
      },
      name: 'Plot evidence',
      folderNumber: 1,
      orderIndex: 1,
      requiredActors: 7,
    },
  ],
  Event: [
    {
      id: '00c79aa7-f992-441c-b440-28c42b1efac3',
      attendingActors: 6,
      createdAt: '2021-10-09T15:52:11.714Z',
      deletedAt: null,
      discountCode: 'AUTUMN30',
      dressCode: 'None',
      eventCatId: null,
      eventCode: 'AT456A',
      eventDate: {
        date: '2021-10-13',
        time: '13:00',
      },
      date: '2021-10-13',
      time: '13:00',
      eventDirector: {
        id: '94276cd9-0157-4178-94de-f08f00465b7b',
        firstName: 'Tamas',
        lastName: 'Knisz',
      },
      eventLocation: {
        id: 'c177964a-56d6-45a4-9aae-0fc6ac5bed3f',
        name: 'Royal Mall',
      },
      eventLocationId: { id: 'c177964a-56d6-45a4-9aae-0fc6ac5bed3f' },
      evidenceCode1: '1234',
      evidenceCode2: '4567',
      evidenceCode3: '6789',
      name: 'Grumpsy event',
      plot: {
        id: '7c4b116d-6388-4a78-a610-507acc855339',
        name: 'The Peacock str. strangler',
      },
      plotImage: {
        url: 'https://murder57-dev-assets.s3.eu-west-2.amazonaws.com/plot-image-dev/7b652255-60f8-4435-8fbf-165668f53761?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=ASIA55IYKY7GK5IAPHWI%2F20211014%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20211014T143326Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEL%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEaCXVzLWVhc3QtMSJHMEUCIQDsR8NlXCITu7lYBxrtSuVMLxkxlPM77yI1oCsvY7iqkwIgMwcr%2FtzfBwSI36%2FUtz0U5jJ9Fr%2BhF9egkMQrpKlFYOIqpQIISBAAGgw5NTYyMTgxMzI0MjgiDMmpGzP6dYvElEGzNyqCAvmwu81OOh55Db%2BlJMB6wyUBiATOOzMyue0QIeVqhTJDRzGtjYmnEHl5sd%2BPTvNYlbtufAmMkWlv0ka%2FTuWfsxuVXCVKrFpglAAwcg1kBI6x51BK7%2BDsYq%2BWHTOiZVRGD4R%2BRnqXG5%2FUkfZZAX6C2lsWNsQsbVFiGbFouMLeMiEkuuINZ%2F9RXPpKGbHEKKChqRfrLw08c5N6nc82OxHhG7xyKTjc%2BmRSGle85IlCTEEjh0l7jKnQnHYr82ROemRb6OLWCG9VrnunpIEB4xMzdtdHRGfpU6khxp0yeO1Y%2FHV3uj021moo3546tUIwNhQt0uwTbYDQbS%2Br%2FSvhEj1VHuOqzDC2%2F6CLBjqdAfNxeQhUcpS%2F526LM0kaB%2F5uZtShSYimaejOG%2BQ5IW2SV4aX93G14lDjFOh3G0D3fFV2vDXds9TTtAkpSsEr7yL8HVMA5LYqSDStYrh8Z9HTJc5QsFp9jFZlD%2F938XKhmVviKGbn6p2ptGwav4DevYZar22IUyHvq5XhKX0OHPh3%2Bo0u9%2BsIjf5%2B50XXllAF1eLNop%2BUDWivijkZ%2F9g%3D&X-Amz-Signature=6dfd511186945d1b61a1a20fe06e3ab959a62fe26d32a5fa3617a61a705e1250&X-Amz-SignedHeaders=host',
      },
      plotIntroduction: '<p>Some desc</p>',
      status: 'PUBLISHED',
      suspectsCode: '1924',
      updatedAt: '2021-10-09T15:52:11.714Z',
    },
  ],
  EventSleuth: [
    {
      id: '32b69fb3-0dcd-407c-85fc-fef3d8e5ae11',
      event: {
        attendingActors: 3,
        createdAt: '2021-10-19T09:25:00.309Z',
        deletedAt: null,
        discountCode: 'AUTUMN30',
        dressCode: 'None',
        eventCatId: null,
        eventCode: '1234JP',
        eventDate: {
          date: '2021-10-22',
          time: '10:24',
          __typename: 'LocalDateTime',
        },
        eventDateISO: '2021-10-22T08:24:00.000Z',
        eventDirector: {
          email: 'tamas.knisz@thedistance.co.uk',
          firstName: 'Tamas',
          id: '94276cd9-0157-4178-94de-f08f00465b7b',
          lastName: 'Knisz',
          role: 'SUPER_ADMIN',
        },
        eventLocation: {
          id: 'c177964a-56d6-45a4-9aae-0fc6ac5bed3f',
          name: 'Royal Mall',
          __typename: 'Location',
        },
        eventLocationId: {
          id: 'c177964a-56d6-45a4-9aae-0fc6ac5bed3f',
          name: 'Royal Mall',
          __typename: 'Location',
        },
        evidenceCode1: '1234',
        evidenceCode2: '4567',
        evidenceCode3: '6789',
        id: '97ab355f-951e-417d-acb4-11513c988560',
        name: 'Garibaldi Junior',
        plot: {
          id: '1645e21b-af1b-4e09-8dc8-e7f59dbe288a',
          name: "Mr. Custard's Dinner",
          __typename: 'Plot',
        },
        plotImage: {
          url: 'https://murder57-dev-assets.s3.eu-west-2.amazonaws.com/plot-image-dev/02708a34-320a-407d-bc1a-019241bcb61a?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=ASIA55IYKY7GON6JPB67%2F20211025%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20211025T151652Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEMj%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEaCXVzLWVhc3QtMSJGMEQCIFSmWEY5%2Bg6piuCDzioL4%2BS54eV0ep6qLkCQ2XePtXaqAiAFdPX%2BYIzPj0cNFOv0ZlzF7FXqbGGlFi5Gk3%2Bl0iTM6iqlAghgEAAaDDk1NjIxODEzMjQyOCIMIRkUN3PAX9sz54gIKoICkABBUaxxzv841oOl7OINeAccNhzJyEtWHHwYM4nliQCROAZ01mp66OY3pyIqhCUCpeeydxqxolUwRe6xGaQCR8V0kjF9hP3AQil8WVBxnGJ1t8cYeAjlrS0FoRaRDX%2F34dpaSAoGddsQIXKhw1Fhk%2B0ck5zhPNMICM5BF2agqibFXPydYOXh2r7HQpeLTlX582ODCm0O9k7gj6GCRDELWBKHKrwlzC%2BI21uPBrr3n7vJRZ1q90lppwDuN%2BWj3fPdmG4Zl3o4gAdxpgz8asu%2FkOt8EB9JrknFAD6g4QuJafmhpb4ArpZsQsYxQoGNF8WA44XgbDb5ONgJMA0jTVtgDd1CMOSU24sGOp4BPmGhqe4KmXru%2FZLswR08NAEQYhXJ%2BA2GdCI0tYuHASqQ2Ta%2B7wtXRtj9KjtUE%2BYxJAGnDb6%2BJ%2FaEM1e49O%2BVRv7%2B0fVnipzNpZQRFv1uz6MmkXXdErpf6OfuTAYv12eLxlzZ5%2F6IMviHTq0xrW%2FBoVVWs505pRfnZr7SBpjadPiOG3kbhuEXpN2HUeI7Xyx0Ztd3gR1TVCSq0L%2Ff5a0%3D&X-Amz-Signature=a761002498eb45b47615667205f48f819beb71976b14e93f62721518d13962db&X-Amz-SignedHeaders=host',
        },
        plotIntroduction: '<p>Story</p>',
        status: 'PUBLISHED',
        suspectsCode: '1234',
        updatedAt: '2021-10-23T22:41:59.842Z',
      },

      sleuthName: 'Samuel Ologunowa',
      sleuthEmail: 'samuelologunowa@gmail.com',
      eventSuspect: {
        id: '49324602-60d5-4964-8238-d22034805ab9',
        eventId: '97ab355f-951e-417d-acb4-11513c988560',
        plotSuspect: {
          createdAt: '2021-09-30T10:03:25.558Z',
          deletedAt: null,
          id: 'c17c3ce3-4bcd-45ff-967a-03cc7d311b83',
          motive: null,
          murderBoxChecked: false,
          name: 'Elisabeth Snakehole',
          plotId: '1645e21b-af1b-4e09-8dc8-e7f59dbe288a',
          priorityNumber: 4,
          updatedAt: '2021-09-30T10:03:25.558Z',
        },

        name: 'Elisabeth Snakehole',
        priorityNumber: 4,
        murderBoxChecked: false,
        motive: null,
        createdAt: '2021-10-19 09:25:00.725418 +00:00',
        updatedAt: '2021-10-19 09:30:36.609234 +00:00',
        deletedAt: null,
        updatedBy: '94276cd9-0157-4178-94de-f08f00465b7b',
      },

      suspectName: 'Emilia Bonfire',
      evidence: 'Some evidence',
      isSuperSleuth: 'No',
      isIntentional: 'Yes',
      awardedAt: null,
      awardedBy: null,
      updatedBy: null,
      createdAt: '2021-10-25 12:25:52.320635 +00:00',
      updatedAt: '2021-10-25 12:25:52.320635 +00:00',
    },
  ],
};
